import { FunctionComponent } from 'preact';
import { useState } from 'preact/hooks';
import './MastheadImage.css';
import { PlaceholderCover } from '../../BooksGrid/PlaceholderCover';

interface MastheadImageProps {
  book: any;
  cdnUrl: string;
  baseBookCoverImageUrl: string;
}

export const MastheadImage: FunctionComponent<MastheadImageProps> = ({
  book,
  cdnUrl,
  baseBookCoverImageUrl,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <a
      href={`/f/${book.permalink}`}
      className="masthead-book-cover"
      title={book.title}
    >
      {book.coverImageThumb ? (
        <img
          src={`${cdnUrl}${baseBookCoverImageUrl}${book.coverImageThumb}`}
          alt={`Cover for ${book.title}`}
          className={`masthead-image ${imageLoaded ? 'loaded' : ''}`}
          onLoad={() => setImageLoaded(true)}
        />
      ) : (
        <PlaceholderCover text={book.title} size="small" />
      )}
    </a>
  );
};
